import { Component, OnInit } from '@angular/core';
import {Breadcrumb, BreadcrumbService} from '../../../service/breadcrumb.service';

@Component({
    selector: 'breadcrumb',
    template: `
	    <nav aria-label="breadcrumb">
		    <ol class="breadcrumb">
			    <li *ngFor="let breadcrumb of breadcrumbs; let last = last; let first = first"
			        class="breadcrumb-item"
			        [ngClass]="{'active': last}">
				    <a *ngIf="!last" [routerLink]="breadcrumb.url">
					    <i *ngIf="first" class="fa fa-home"></i>
					    <span *ngIf="!first">{{ breadcrumb.label }}</span>
				    </a>
				    <span *ngIf="last">
                        <i *ngIf="first" class="fa fa-home"></i>
                        <span *ngIf="!first">{{ breadcrumb.label }}</span>
                    </span>
			    </li>
		    </ol>
	    </nav>
  `,
    styles: [`
        .breadcrumb {
            display: flex;
            align-items: center;
            padding: 0.5rem 1rem;
            list-style: none;
            background-color: transparent; /* Remove background */
        }

        .breadcrumb-item {
            display: inline-flex;
            align-items: center;
            margin-right: 0;
            padding-left: 0;
        }

        .breadcrumb-item::before {
            content: '';
        }

        .breadcrumb-item:not(:first-child) {
            margin-left: -1.75rem !important;
        }

        .breadcrumb-item:first-child {
            z-index: 10;
        }

        .breadcrumb-item:nth-child(1) {
            z-index: 9;
        }

        .breadcrumb-item:nth-child(2) {
            z-index: 8;
        }

        .breadcrumb-item:nth-child(3) {
            z-index: 7;
        }

        .breadcrumb-item:nth-child(4) {
            z-index: 6;
        }

        .breadcrumb-item:nth-child(5) {
            z-index: 5;
        }

        .breadcrumb-item:nth-child(6) {
            z-index: 4;
        }

        .breadcrumb-item:nth-child(7) {
            z-index: 3;
        }

        .breadcrumb-item:nth-child(8) {
            z-index: 2;
        }

        .breadcrumb-item:nth-child(9) {
            z-index: 1;
        }

        .breadcrumb-item a, .breadcrumb-item span {
            display: inline-flex;
            align-items: center;
            padding: 0.25rem 1rem;
            background-color: #fff; /* White background for pill */
            border-radius: .35rem 2rem 2rem .35rem;
            color: var(--accent); /* Dark blue text */
            font-weight: bold;
            text-transform: uppercase;
            text-decoration: none; /* Remove underline from links */
            font-size: 0.9rem;
        }

        .breadcrumb-item a {
            -moz-box-shadow: 5px 0 5px -2px #A1A1A1;
            -webkit-box-shadow: 5px 0 5px -2px #A1A1A1;
            box-shadow: 5px 0 5px -2px #A1A1A1;
        }

        .breadcrumb-item:first-child a {
            padding-top: .5rem;
            padding-bottom: .5rem;
        }

        .breadcrumb-item.active span {
            background-color: #fff; /* Ensure active item has same background */
            color: var(--accent); /* Same color for active item */
        }

        .breadcrumb-item a:hover {
            background-color: #fff; /* Light gray on hover */
        }

        .breadcrumb-item i.fa-home {
            color: #f28c38; /* Orange color for house icon */
            font-size: 1.5em;
        }

        .breadcrumb-item a:hover span {
            color: #f28c38; /* Orange color for hover text */
        }

        /* Small devices (portrait phones, less than 576px) */
        @media (max-width: 575.98px) {
            .breadcrumb {
                flex-wrap: wrap;
                margin-bottom: .5rem;
                padding: 0.25rem .5rem;
            }

            .breadcrumb-item {
                margin-bottom: 0.1rem;
            }

            .breadcrumb-item:first-child {
                margin-left: 0;
            }

            .breadcrumb-item:first-child a {
                padding-top: .35rem;
                padding-bottom: .35rem;
            }

            .breadcrumb-item a, .breadcrumb-item span {
                padding: 0.175rem .75rem;
                border-radius: .35rem 2rem 2rem .35rem;
                font-size: .75em;
            }
        }`]
})
export class BreadcrumbComponent implements OnInit {
    breadcrumbs: Breadcrumb[] = [];

    constructor(private breadcrumbService: BreadcrumbService) {}

    ngOnInit(): void {
        this.breadcrumbService.breadcrumbs$.subscribe(
            (breadcrumbs: Breadcrumb[]) => this.breadcrumbs = breadcrumbs
        );
    }
}